import getList from './getList';
import add from './add';
import edit from './edit';
import del from './del';
import getDetail from './getDetail';
import editAuth from './editAuth';
export default {
  getList,
  add,
  del,
  edit,
  getDetail,
  editAuth
};


// WEBPACK FOOTER //
// ./src/api/usermanagergroups/index.ts